<template>
  <div>
    <Headline :level="2">会員情報</Headline>
    <div class="form-group">
      <label class="confirm">お名前</label>
      <p class="text-paragraph">{{ account.name | with-empty }}</p>
    </div>
    <div class="form-group">
      <label class="confirm">会員番号</label>
      <p class="text-paragraph">{{ account.cmc_no | with-empty }}</p>
    </div>
    <div class="form-group">
      <label class="confirm">メールアドレス</label>
      <p class="text-paragraph text-break">{{ account.mail | with-empty }}</p>
    </div>
    <div class="form-group">
      <label class="confirm">お電話番号</label>
      <p class="text-paragraph">{{ tel | with-empty }}</p>
    </div>
    <div class="form-group">
      <label class="confirm">生年月日</label>
      <p class="text-paragraph">{{ account.birth_date | formatDate | with-empty }}</p>
    </div>
    <div class="form-group" v-if="!account.divorce">
      <label class="confirm">ご結婚記念日</label>
      <p class="text-paragraph">{{ account.wedding_anniversary_date | formatDate | with-empty }}</p>
    </div>
    <div class="form-group account_address1" v-if="!account.past_enforcement">
      <label class="confirm account_address1_confirm">住所（ご成約時の住所）</label>
      <p class="text-paragraph account_address1_text">{{ address1 | with-empty }}</p>
    </div>
    <div class="form-group account_address2">
      <label class="confirm account_address2_confirm">住所（新居）</label>
      <p class="text-paragraph account_address2_text">{{ address2 | with-empty }}</p>
    </div>
    <ChildInfo v-if="childInfoFlag"
      :edit="false"
      :child-info="childInfo"
      :child-info-flag="childInfoFlag"
    />
    <template v-if="account.shipments.length > 0">
      <Headline :level="2">配信メール情報</Headline>
      <template v-if="sendMails.length > 0">
        <Headline :level="3">受け取る情報</Headline>
        <div class="form-group">
          <ul class="check-list">
            <li
              class="check-list-item"
              v-for="(mail, index) in sendMails"
              :key="`ship-yes-${index}`"
            >
              {{ mail.name }}
            </li>
          </ul>
        </div>
      </template>
      <template v-if="notSendMails.length > 0">
        <Headline :level="3">受け取らない情報</Headline>
        <div class="form-group">
          <ul class="check-list">
            <li
              class="check-list-item"
              v-for="(mail, index) in notSendMails"
              :key="`ship-no-${index}`"
            >
              {{ mail.name }}
            </li>
          </ul>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import withEmpty from '@/filters/with-empty'
import { formatDate } from '@/filters/format-date'
import ChildInfo from '@/components/ChildInfo'

// お客様情報編集 確認画面
export default {
  props: {
    account: {
      type: Object,
      required: true
    },
    childInfo: {
      type: Array,
      required: true
    },
    childInfoFlag: {
      type: Boolean,
      required: false,
      default: () => { return false }
    }
  },
  components: {
    ChildInfo
  },
  computed: {
    tel() {
      const {
        tel_area_no: tel1,
        tel_local_no: tel2,
        tel_no: tel3 } = this.account

      return (tel1 && tel2 && tel3) ? `${tel1}-${tel2}-${tel3}` : ''
    },
    address1() {
      const {
        address1_postcode1: zipcode1,
        address1_postcode2: zipcode2,
        address1_billing_state: prefecture,
        address1_billing_city: city,
        address1_billing_street: town,
        address1_building_name: building
      } = this.account

      const zip = (zipcode1 && zipcode2) ? `〒${zipcode1}-${zipcode2} ` : ''

      return `${zip}${prefecture}${city}${town}${building}`
    },
    address2() {
      const {
        address2_postcode1: zipcode1,
        address2_postcode2: zipcode2,
        address2_billing_state: prefecture,
        address2_billing_city: city,
        address2_billing_street: town,
        address2_building_name: building
      } = this.account

      const zip = (zipcode1 && zipcode2) ? `〒${zipcode1}-${zipcode2} ` : ''

      return `${zip}${prefecture}${city}${town}${building}`
    },
    // 受け取る情報
    sendMails() {
      return this.account.shipments.filter(shipment => shipment.value)
    },
    // 受け取らない情報
    notSendMails() {
      return this.account.shipments.filter(shipment => !shipment.value)
    }
  },
  filters: {
    withEmpty,
    formatDate
  }
}
</script>
